import { render, staticRenderFns } from "./patient_list.vue?vue&type=template&id=4e523b94&"
import script from "./patient_list.vue?vue&type=script&lang=js&"
export * from "./patient_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports